import { render } from "./PodcastGuestGuide.vue?vue&type=template&id=3811ed70"
import script from "./PodcastGuestGuide.vue?vue&type=script&lang=js"
export * from "./PodcastGuestGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__